import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeService } from '@app/core/theme/theme.service';
import { ProfileFacade } from '@app/store/profile';
import { AvatarComponent, IconComponent } from '@shared/components';

/** Foot of the sidebar: the signed-in user (links to the profile), theme switch and sign-out. */
@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css'],
    imports: [RouterLink, RouterLinkActive, TranslatePipe, AvatarComponent, IconComponent],
})
export class AccountComponent {
    private readonly profileFacade = inject(ProfileFacade);
    readonly themeService = inject(ThemeService);

    readonly profile = this.profileFacade.profile;

    readonly name = computed(() => {
        const user = this.profile();

        return user ? `${user.firstname} ${user.lastname}`.trim() : '';
    });

    readonly initials = computed(() => {
        const user = this.profile();

        return user ? `${user.firstname.charAt(0)}${user.lastname.charAt(0)}`.toUpperCase() : '';
    });
}
